module.exports = __webpack_public_path__ + "img/26.2.TN.9ef0a1be.png";